import React, { FC } from 'react';
import SegmentedRadioButton from 'src/react_components/form-helpers/segmented-radio-button';

type Segment = {
  text: string;
  value: string;
  id: string;
  disabled?: boolean;
};

type Props = {
  segments: Segment[];
  name: string;
  value: string;
  disabled?: boolean;
  managedValue?: boolean;
  controlled?: boolean;
  vertical?: boolean;
  labelClassNames?: string;
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
};

const SegmentedRadioButtons: FC<Props> = (props) => {
  const {
    segments,
    name,
    value,
    disabled,
    managedValue,
    controlled,
    vertical,
    labelClassNames,
    onChange
  } = props;

  const checkedProps = (segment: Segment) => {
    if (controlled) {
      return { controlled: true, checked: (managedValue ? value === segment.value : undefined) };
    }

    return { defaultChecked: value === segment.value };
  };

  const classNames = ['RadioGroupButtons RadioGroupButtons--grouped RadioGroupButtons--compact'];
  classNames.push(vertical ? 'RadioGroupButtons--column' : 'u-flexNoWrap flex-nowrap');

  let labelClasses = vertical ? '' : 'u-whiteSpaceNoWrap text-nowrap';
  labelClasses += labelClassNames ? ` ${labelClassNames}` : '';

  return (
    <div className="segmented">
      <div
        className={classNames.join(' ')}
        role="group"
        onChange={onChange}
        // @ts-ignore
        name={name}
      >
        {segments.map((segment: Segment) => (
          <SegmentedRadioButton
            text={segment.text}
            value={segment.value}
            id={`${name}${segment.id}`}
            key={segment.value}
            name={name}
            disabled={disabled || segment.disabled}
            labelClassNames={labelClasses}
            {...checkedProps(segment)}
          />
        ))}
      </div>
    </div>
  );
};

export default SegmentedRadioButtons;
